// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"90755c45","304":"139c84c5","436":"df92c87a","590":"2389c077"}[chunkId] + ".chunk.js";
};